import Vue from 'vue'
import vuetify from "@/plugins/vuetify";
import App from "@/App.vue";
import FlagIcon from 'vue-flag-icon'
import axios from "axios";
import i18n from "@/i18n";
import router from '@/router'
import store from "@/store";
import VueTheMask from 'vue-the-mask'
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
require('dayjs/locale/uz-latn')
require('dayjs/locale/ru')
import utc from 'dayjs/plugin/utc';
import VueApexCharts from 'vue-apexcharts'


dayjs.extend(relativeTime);
dayjs.extend(utc)
import '@/assets/css/main.css'
import VueSweetalert2 from "vue-sweetalert2";
import 'sweetalert2/dist/sweetalert2.min.css';

window.axios = axios;
Vue.prototype.$dayjs = dayjs;
Vue.use(FlagIcon)
Vue.use(VueTheMask)
Vue.use(VueSweetalert2);
Vue.component('VApexchart', VueApexCharts)
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;


const HelloJs = require('hellojs/dist/hello.all.min.js');
const VueHello = require('vue-hellojs');

HelloJs.init({
    google: process.env.VUE_APP_GOOGLE_CLIENT_ID,
}, {
    scope: "profile email",
    redirect_uri: window.location.origin + "/login"
});
Vue.use(VueHello, HelloJs);
window.axios.defaults.baseURL = process.env.VUE_APP_API_URL;

new Vue({
    vuetify,
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')

axios.interceptors.request.use(function (config) {
    config.headers.Authorization = "Bearer " + store.getters.token;
    config.headers.Applocale = i18n.locale
    return config;
});



window.$echo = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_KEY,
    cluster: 'mt1',
    wsHost: process.env.VUE_APP_PUSHER_HOST,
    wsPort: 80,
    wssPort: 443,
    authEndpoint: `${process.env.VUE_APP_API_URL}/broadcasting/auth`,
    forceTLS: process.env.VUE_APP_PUSHER_SCHEME === "https",
    encrypted: process.env.VUE_APP_PUSHER_SCHEME === "https",
    disableStats: process.env.VUE_APP_PUSHER_SCHEME === "https",
    enabledTransports: ['ws', 'wss'],
    auth: {
        headers: {
            Authorization: `Bearer ${store.getters.token}`, // If using Sanctum or Passport
            Accept: "application/json",
        },
        withCredentials: true,
    },
});




if (process.env.VUE_APP_DEBUG !== 'true')
{
    document.addEventListener("contextmenu", (event) => event.preventDefault());

    document.addEventListener("keydown", (event) => {
        if (
            event.ctrlKey &&
            (event.key === "u" || event.key === "U" || event.key === "s" || event.key === "S")
        ) {
            event.preventDefault();
        }
        if (
            event.ctrlKey && event.shiftKey &&
            (event.key === "I" || event.key === "J" || event.key === "C")
        ) {
            event.preventDefault();
        }
        if (event.key === "F12") {
            event.preventDefault();
        }
    });
}